import './HBreadCrumbs.scss';

import * as tsx from 'vue-tsx-support';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { HLink, HIcon } from '~/components';

export interface HBreadCrumbsItem {
  to: string;
  title: string;
}

export interface HBreadCrumbsProps {
  items?: HBreadCrumbsItem[];
}

export interface HBreadCrumbsEmits {}

export interface HBreadCrumbsScopedSlots {}

@Component<HBreadCrumbsRef>({
  name: 'HBreadCrumbs',
  render() {
    const { items } = this;

    if (!items || !items.length) {
      return undefined as any;
    }

    const lastIndex = items.length - 1;

    return (
      <nav class="h-bread-crumbs">
        <ol>
          {items.map((item, index) => {
            const isLast = lastIndex === index;
            return (
              <li
                class="h-bread-crumbs__list"
                key={`breadCrumbsList-${item.to}`}>
                <HLink
                  staticClass="h-bread-crumbs__link"
                  class={isLast ? 'disabled' : ''}
                  to={{ path: item.to }}>
                  {item.title}
                </HLink>
                {!isLast && (
                  <HIcon
                    key={`icon-${index}`}
                    staticClass="h-bread-crumbs__icon"
                    name="keyboard-arrow-right"
                  />
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    );
  },
})
export class HBreadCrumbsRef extends Vue implements HBreadCrumbsProps {
  @Prop({ type: Array }) readonly items!: HBreadCrumbsItem[];
}

/** パンくずリストコンポーネント */
export const HBreadCrumbs = tsx
  .ofType<HBreadCrumbsProps, HBreadCrumbsEmits, HBreadCrumbsScopedSlots>()
  .convert(HBreadCrumbsRef);
